export interface BasePcList {
  id: string; // 标识 id
  name: string; // 路由 name
  path: string; // 路由 path
  desc?: string; // 描述
  link?: string; // 只需 pc
  macUrl?: string; // 只需 mac
  pcLink?: string; // 需要多个下载 pc
  azLink?: string; // 需要多个下载 az
  iosLink?: string; // 需要多个下载 ios
  macLink?: string; // 需要多个下载 ios
  hosLink?: string; // 需要多个下载 hos
  sendAplus?: boolean; // 需要发送(window as any).aplus_queue
  isRequest?: boolean; // 需要百度转化API上报
  isSougouJs?: boolean; // 需要发送搜狗js
  isBaiduApiToken?: string; // 需要百度上报apitoken拼接
  IDX?: number; // 类型1 代表360 不传则是百度 后面又其他的再新增类型
  key?: string; // 需要360上报api拼接  msclk-微软 yklk-优酷 sougoulk-搜狗 aqylk-爱奇艺
  Secret?: string; // 需要360上报api拼接
  collectMsclkId?: boolean; // 需要微软上报id
  collectYKlkId?: boolean; // 需要优酷上报id
  collectSGlkId?: boolean; // 需要搜狗上报id
  collectAqylkId?: boolean; // 需要爱奇艺上报id
  bingType?: number; // 微软上报type区分
}

export const basePcList: BasePcList[] = [
  {
    id: "1",
    name: "360",
    path: "/360",
    pcLink: "//static.dhsf.996box.com/box/channel_app/996boxSetup@6116.exe",
    azLink: "/static/img/baseImg/download/360_download_android.png",
    hosLink: "/static/img/baseImg/download/360_download_android.png",
    iosLink: "/static/img/baseImg/download/base_download_ios.png",
    macLink: "/static/img/baseImg/download/sougou_download_android.png",
    macUrl:
      "//static.dhsf.996box.com/box/channel_app/73B779C9142708A180B324799346DC1B.dmg",
    sendAplus: true,
  },
  {
    id: "2",
    name: "wb",
    path: "/wb",
    pcLink: "//static.dhsf.xqhuyu.com/temporary_file/1657778073000_wHhFp.exe",
    azLink: "/static/img/baseImg/download/wb_download_android.png",
    iosLink: "/static/img/baseImg/download/base_download_ios.png",
  },
  {
    id: "4",
    name: "sougou",
    path: "/sougou",
    pcLink: "//static.dhsf.xqhuyu.com/box/channel_app/996boxSetup@6014.exe",
    azLink: "/static/img/baseImg/download/sougou_download_android.png",
    hosLink: "/static/img/baseImg/download/sougou_download_android.png",
    iosLink: "/static/img/baseImg/download/sougou_download_android.png",
    macLink: "/static/img/baseImg/download/sougou_download_android.png",
    macUrl:
      "//static.dhsf.996box.com/box/channel_app/73B779C9142708A180B324799346DC1B.dmg",
  },
  {
    id: "6",
    name: "2345",
    path: "/2345",
    pcLink: "//static.dhsf.xqhuyu.com/box/channel_app/996boxSetup@6029.exe",
    azLink: "/static/img/baseImg/download/360_download_android.png",
    hosLink: "/static/img/baseImg/download/360_download_android.png",
    iosLink: "/static/img/baseImg/download/base_download_ios.png",
    macLink: "/static/img/baseImg/download/sougou_download_android.png",
    macUrl:
      "//static.dhsf.996box.com/box/channel_app/73B779C9142708A180B324799346DC1B.dmg",
    sendAplus: true,
  },
  {
    id: "7",
    name: "tieba",
    path: "/tieba",
    link: "//static.dhsf.996box.com/box/channel_app/boxSetup@6079.exe",
  },
  {
    id: "8",
    name: "xunyou",
    path: "/xunyou",
    pcLink: "//static.dhsf.xqhuyu.com/box/channel_app/1661762599000_ek2kX.exe",
    azLink: "/static/img/baseImg/download/xunyou_download_android.png",
  },
  {
    id: "9",
    name: "07073",
    path: "/07073",
    pcLink: "//static.dhsf.xqhuyu.com/box/channel_app/996boxSetup@6035.exe",
    azLink: "/static/img/baseImg/download/07073_download_android.png",
  },
  {
    id: "13",
    name: "sw360",
    path: "/sw360",
    link: "//static.dhsf.xqhuyu.com/box/channel_app/1666149756000_8KTdK.exe",
  },
  {
    id: "14",
    name: "xunlan",
    path: "/xunlan",
    pcLink: "//static.dhsf.xqhuyu.com/box/channel_app/996box@6043.exe",
    azLink: "/static/img/baseImg/download/xunlan_download_android.png",
  },
  {
    id: "15",
    name: "yueke1",
    path: "/yueke1",
    link: "//static.dhsf.xqhuyu.com/box/channel_app/996box@6044.exe",
    isRequest: true,
  },
  {
    id: "17",
    name: "cnxh",
    path: "/cnxh",
    link: "//static.dhsf.996box.com/box/channel_app/996Setupbox@6064.exe",
  },
  {
    id: "19",
    name: "baidu7",
    path: "/baidu7",
    link: "//static.dhsf.996box.com/box/channel_app/996boxSetup@6068.exe",
    isBaiduApiToken:
      "7ERIXG003auS3904Knf6b26XwRF3O8rH@3d3cPSSF3TUdpf5fqnCye4qWMjPdAVX2",
  },
  {
    id: "20",
    name: "lx",
    path: "/lx",
    link: "//static.dhsf.996box.com/box/channel_app/boxSetup@6081.exe",
  },
  {
    id: "21",
    name: "sougou4",
    path: "/sougou4",
    pcLink: "//static.dhsf.996box.com/box/channel_app/996boxSetup@6082.exe",
    azLink: "/static/img/baseImg/download/biyingjj_download_android.png",
    iosLink: "/static/img/baseImg/download/biyingjj_download_ios.png",
    isSougouJs: true,
    collectSGlkId: true,
    IDX: 1,
    key: "sougoulk",
    Secret: "1",
  },
  {
    id: "23",
    name: "baidu14",
    path: "/baidu14",
    link: "//static.dhsf.996box.com/box/channel_app/996boxSetup@6085.exe",
    desc: "http://996box.pc996box.427.cn",
    isRequest: true,
    isBaiduApiToken:
      "NtElS6jQh7zHvUOLLpbUiTvWxcvGeot6@t7uit1ruIAMsEKKGMGaTIYengT32VCxa",
  },
  {
    id: "24",
    name: "by",
    path: "/by",
    pcLink:
      "//static.dhsf.996box.com/box/channel_app/996box390SetupSigned@6109.exe",
    azLink: "/static/img/baseImg/download/biyingjj_download_android.png",
    iosLink: "/static/img/baseImg/download/biyingjj_download_ios.png",
  },
  {
    id: "25",
    name: "fb1",
    path: "/fb1",
    link: "//static.dhsf.996box.com/box/channel_app/996box507SetupSigned@7005.exe",
    desc: "http://996box.pc996box.427.cn",
    isRequest: true,
    isBaiduApiToken:
      "TRixfpKwzuOPQtlL4f7O03mO4lRrrm17@w30YEWvRKYEGqNRppBS7lITCzpUygnA3",
  },
  {
    id: "26",
    name: "fb2",
    path: "/fb2",
    link: "//static.dhsf.996box.com/box/channel_app/996box507SetupSigned@7004.exe",
    desc: "http://996box.pc996box.427.cn",
    isRequest: true,
    isBaiduApiToken:
      "HRV1Fzkl14vgCtBxkcVANB8jNz0ULjcR@K2graNjvqgaqu9L9AEP5yQf1a3nm3AHE",
  },
  {
    id: "48",
    name: "fb3",
    path: "/fb3",
    link: "//static.dhsf.996box.com/box/channel_app/996box511SetupSigned@7007.exe",
    desc: "http://996box.pc996box.427.cn",
    isRequest: true,
    isBaiduApiToken:
      "7ERIXG003auS3904Knf6b26XwRF3O8rH@3d3cPSSF3TUdpf5fqnCye4qWMjPdAVX2",
  },
  {
    id: "45",
    name: "bdfb",
    path: "/bdfb",
    link: "//static.dhsf.996box.com/box/channel_app/996box507SetupSigned@7003.exe",
    desc: "http://www.996box.com/bdfb",
    isRequest: true,
    isBaiduApiToken:
      "Hh2EkEbz0VQ3TrXjHpudaEetXbceIDnL@eURUpIJZbyhcuYfcdQlGPXfaPbd43tch",
  },
  {
    id: "46",
    name: "biyingjjfb",
    path: "/biyingjjfb",
    link: "//static.dhsf.996box.com/box/channel_app/996box507SetupSigned@7001.exe",
    desc: "https://ml.996box.com/biyingjjfb",
    collectMsclkId: true,
    bingType: 1,
    IDX: 1,
    key: "msclk",
    Secret: "1",
  },
  {
    id: "47",
    name: "dxaqy",
    path: "/dxaqy",
    link: "//static.dhsf.996box.com/box/channel_app/996box507SetupSigned@6192.exe",
    desc: "https://www.996box.com/dxaqy",
    collectAqylkId: true,
    IDX: 1,
    key: "aqylk",
    Secret: "1",
  },
  {
    id: "27",
    name: "fb/gameDetail",
    path: "/fb/gameDetail",
    link: "//static.dhsf.996box.com/box/channel_app/996boxV340SetupSigned1697521204@6087.exe",
    desc: "http://996box.pc996box.427.cn",
    isRequest: true,
    isBaiduApiToken:
      "7mnY4PCZMSKWHdk8DY6mfiIRWp94XaKw@B66bfBzYSLoj20o8kKrh5LrGr8cXu7RG",
  },
  {
    id: "28",
    name: "360sf1",
    path: "/360sf1",
    link: "//static.dhsf.996box.com/box/channel_app/996boxV340SetupSigned@6091.exe",
    desc: "http://996box.pc996box.427.cn",
    isRequest: true,
    isBaiduApiToken:
      "HRV1Fzkl14vgCtBxkcVANB8jNz0ULjcR@K2graNjvqgaqu9L9AEP5yQf1a3nm3AHE",
    IDX: 1,
    key: "rjplaws35dnidn6c6bvt",
    Secret: "0ycsi0vb7i7z5ajxef0giq6d4r4en6kl",
  },
  {
    id: "29",
    name: "360sf1/gameDetail",
    path: "/360sf1/gameDetail",
    link: "//static.dhsf.996box.com/box/channel_app/996boxV340SetupSigned@6091.exe",
    desc: "http://996box.pc996box.427.cn",
    isRequest: true,
    isBaiduApiToken:
      "HRV1Fzkl14vgCtBxkcVANB8jNz0ULjcR@K2graNjvqgaqu9L9AEP5yQf1a3nm3AHE",
    IDX: 1,
    key: "rjplaws35dnidn6c6bvt",
    Secret: "0ycsi0vb7i7z5ajxef0giq6d4r4en6kl",
  },
  {
    id: "37",
    name: "biying",
    path: "/biying",
    link: "//static.dhsf.996box.com/box/channel_app/996boxSetup@6112.exe",
  },
  {
    id: "38",
    name: "iqiyi",
    path: "/iqiyi",
    link: "//static.dhsf.996box.com/box/channel_app/996boxSetup@6113.exe",
  },
  {
    id: "39",
    name: "biyingjj",
    path: "/biyingjj",
    pcLink: "//static.dhsf.996box.com/box/channel_app/996boxSetup@6114.exe",
    azLink: "/static/img/baseImg/download/biyingjj_download_android.png",
    iosLink: "/static/img/baseImg/download/biyingjj_download_ios.png",
    collectMsclkId: true,
    bingType: 1,
    IDX: 1,
    key: "msclk",
    Secret: "1",
  },
  {
    id: "40",
    name: "3dm",
    path: "/3dm",
    link: "//static.dhsf.996box.com/box/channel_app/996boxSetup@6115.exe",
  },
  {
    id: "41",
    name: "biyingxxl",
    path: "/biyingxxl",
    link: "//static.dhsf.996box.com/box/channel_app/996boxSetup@6122.exe",
    collectMsclkId: true,
    bingType: 1,
    IDX: 1,
    key: "msclk",
    Secret: "1",
  },
  {
    id: "42",
    name: "biyingjjs",
    path: "/biyingjjs",
    pcLink:
      "//static.dhsf.996box.com/box/channel_app/996box390SetupSigned@6124.exe",
    azLink: "/static/img/baseImg/download/biyingjj_download_android.png",
    iosLink: "/static/img/baseImg/download/biyingjj_download_ios.png",
    collectMsclkId: true,
    bingType: 2,
    IDX: 1,
    key: "msclk",
    Secret: "2",
  },
  {
    id: "43",
    name: "sougou5",
    path: "/sougou5",
    link: "//static.dhsf.996box.com/box/channel_app/996boxV360SetupSigned@6101.exe",
    isSougouJs: true,
  },
  {
    id: "44",
    name: "pdyk",
    path: "/pdyk",
    pcLink:
      "//static.dhsf.996box.com/box/channel_app/996box420SetupSigned@6139.exe",
    azLink: "/static/img/baseImg/download/biyingjj_download_android.png",
    iosLink: "/static/img/baseImg/download/biyingjj_download_ios.png",
    collectYKlkId: true,
    IDX: 1,
    key: "yklk",
    Secret: "1",
  },
  {
    id: "42701",
    name: "yxzq01",
    path: "/yxzq01",
    pcLink: "//static.dhsf.996box.com/box/channel_app/996boxSetup@6117.exe",
    azLink: "/static/img/baseImg/download/biyingjj_download_android.png",
    iosLink: "/static/img/baseImg/download/biyingjj_download_ios.png",
    collectYKlkId: true,
    IDX: 1,
    key: "yklk",
    Secret: "1",
  },
];
